<template>
  <div v-if="countItemsOnShoppingCart() > 0" class="badge shopping-cart-counter-1 badge-primary rounded-pill">
    {{ countItemsOnShoppingCart() }}
  </div>
</template>

<script>
import {countItemsOnShoppingCart} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "ShoppingCartCounter1",
  methods: {
    countItemsOnShoppingCart,
    refreshComponent() {
      this.$forceUpdate()
    }
  },
  async mounted() {
    window.addEventListener(`unauthenticatedShoppingCardData`, () => {
      this.refreshComponent()
    });
  },
}
</script>

<style scoped>

</style>